
const Items =  [
  {
    'pemerintahID': 'PEM-00001',
    'namaInstansi': 'BPSKL Wilayah Sumatera',
    'kontakInstansi': '0617862612',
    'website': 'http://pskl.menlhk.go.id/upt.html',
    'nilaiBantuan': '15000000',
    'tujuanBantuan': "Kelompok Tani Aek Godang, Brastagi, Sumatera Utara",
    'alokasiPenggunaanDana': 'Modal usaha dan kapasitas SDM',
    'jangkaWaktu': '6',

    'indikatorKeberhasilan': '8',
    'alamatDesa': 'SukaMulya',
    'alamatKecamatan': 'Padepokan',
    'alamatKabupaten': 'Bogor',
    'alamatProvinsi': 'Jawa Barat'
  },
  {
    'pemerintahID': 'PEM-00002',
    'namaInstansi': 'BPSKL Wilayah Jawa-Bali dan Nusa Tenggara',
    'kontakInstansi': '036751815',
    'website': 'http://pskl.menlhk.go.id/upt.html',
    'nilaiBantuan': '13000000',
    'tujuanBantuan': "Kelompok Tani Rimba Lestari, Bogor, Jawa Barat",
    'alokasiPenggunaanDana': 'Bantuan peningkatan kapasitas pemasaran produk',
    'jangkaWaktu': '8',

    'indikatorKeberhasilan': '4',
    'alamatDesa': 'SukaMulya',
    'alamatKecamatan': 'Padepokan',
    'alamatKabupaten': 'Bogor',
    'alamatProvinsi': 'Jawa Barat'
  },
  {
    'pemerintahID': 'PEM-00003',
    'namaInstansi': 'BPSKL Wilayah Kalimantan',
    'kontakInstansi': '05117559796',
    'website': 'http://pskl.menlhk.go.id/upt.html',
    'nilaiBantuan': '18000000',
    'tujuanBantuan': "Unit Usaha Rimba Sentosa, Pulang Pisau, Kalimantan Tengah",
    'alokasiPenggunaanDana': 'Pendampingan usaha dan fasilitas pokok kegiatan',
    'jangkaWaktu': '12',

    'indikatorKeberhasilan': '6',
    'alamatDesa': 'SukaMulya',
    'alamatKecamatan': 'Padepokan',
    'alamatKabupaten': 'Bogor',
    'alamatProvinsi': 'Jawa Barat'
  },
  {
    'pemerintahID': 'PEM-00004',
    'namaInstansi': 'BPSKL Wilayah Sulawesi',
    'kontakInstansi': '04115069240',
    'website': 'http://pskl.menlhk.go.id/upt.html',
    'nilaiBantuan': '16000000',
    'tujuanBantuan': "Gapoktan Ukulele, Bulukumba, Sulawesi Selatan",
    'alokasiPenggunaanDana': 'Perencanaan bisnis dan pemasaran',
    'jangkaWaktu': '10',

    'indikatorKeberhasilan': '4',
    'alamatDesa': 'SukaMulya',
    'alamatKecamatan': 'Padepokan',
    'alamatKabupaten': 'Bogor',
    'alamatProvinsi': 'Jawa Barat'
  },
  {
    'pemerintahID': 'PEM-00005',
    'namaInstansi': 'BPSKL Wilayah Maluku Papua',
    'kontakInstansi': '0911354369',
    'website': 'http://pskl.menlhk.go.id/upt.html',
    'nilaiBantuan': '14000000',
    'tujuanBantuan': "Kelompok Tani Liuk Sungkai, Ternate, Maluku Utara",
    'alokasiPenggunaanDana': 'Optimasi hasil produksi dan keuntungan',
    'jangkaWaktu': '7',

    'indikatorKeberhasilan': '5',
    'alamatDesa': 'SukaMulya',
    'alamatKecamatan': 'Padepokan',
    'alamatKabupaten': 'Bogor',
    'alamatProvinsi': 'Jawa Barat'
  },
  {
    'pemerintahID': 'PEM-00006',
    'namaInstansi': 'Dinas Kehutanan Provinsi Jawa Barat',
    'kontakInstansi': '036757654',
    'website': 'http://www.dishut.jabarprov.go.id/',
    'nilaiBantuan': '5000000',
    'tujuanBantuan': "Kelompok Tani Hutan Rakyat Kabupaten Kuningan",
    'alokasiPenggunaanDana': 'Workshop tentang manajemen pohon di hutan rakyat',
    'jangkaWaktu': '1',

    'indikatorKeberhasilan': '7',
    'alamatDesa': 'SukaMulya',
    'alamatKecamatan': 'Padepokan',
    'alamatKabupaten': 'Bogor',
    'alamatProvinsi': 'Jawa Barat'
  },
  {
    'pemerintahID': 'PEM-00007',
    'namaInstansi': 'Dinas Tanaman Pangan, Hortikultura dan Perkebunan Provinsi Riau',
    'kontakInstansi': '061786543',
    'website': 'http://distanbun.riau.go.id/',
    'nilaiBantuan': '8000000',
    'tujuanBantuan': "Kelompok Tani Lancang Kuning, Kabupaten Rokan Hilir",
    'alokasiPenggunaanDana': 'Fasilitasi pengadaan sumber bibit, monitoring tanaman dan sistem pemasaran',
    'jangkaWaktu': '4',

    'indikatorKeberhasilan': '6',
    'alamatDesa': 'SukaMulya',
    'alamatKecamatan': 'Padepokan',
    'alamatKabupaten': 'Bogor',
    'alamatProvinsi': 'Jawa Barat'
  },
  {
    'pemerintahID': 'PEM-00008',
    'namaInstansi': 'Dirjen PSKL KLHK',
    'kontakInstansi': '036757654',
    'website': 'http://pskl.menlhk.go.id/',
    'nilaiBantuan': '24000000',
    'tujuanBantuan': "Gabungan Kelompok Tani Kabupaten Penajam Paser Utara, Kalimantan Timur",
    'alokasiPenggunaanDana': 'Pengembangan multi usaha kehutanan',
    'jangkaWaktu': '12',

    'indikatorKeberhasilan': '9',
    'alamatDesa': 'SukaMulya',
    'alamatKecamatan': 'Padepokan',
    'alamatKabupaten': 'Bogor',
    'alamatProvinsi': 'Jawa Barat'
  },
  {
    'pemerintahID': 'PEM-00009',
    'namaInstansi': 'BLU P3H KLHK',
    'kontakInstansi': '036654287',
    'website': 'https://blup3h.id/',
    'nilaiBantuan': '26000000',
    'tujuanBantuan': "Kelompok Tani Wangi Meubel, Jepara, Jawa Tengah",
    'alokasiPenggunaanDana': 'Hilirisasi produk dan peningkatan kapasitas SDM',
    'jangkaWaktu': '12',

    'indikatorKeberhasilan': '10',
    'alamatDesa': 'SukaMulya',
    'alamatKecamatan': 'Padepokan',
    'alamatKabupaten': 'Bogor',
    'alamatProvinsi': 'Jawa Barat'
  },
  {
    'pemerintahID': 'PEM-00020',
    'namaInstansi': 'BLU P3H KLHK',
    'kontakInstansi': '036654287',
    'website': 'https://blup3h.id/',
    'nilaiBantuan': '24000000',
    'tujuanBantuan': "Kelompok Tani Srikandi Melati, Pandeglang, Banten",
    'alokasiPenggunaanDana': 'Modal usaha',
    'jangkaWaktu': '12',

    'indikatorKeberhasilan': '10',
    'alamatDesa': 'SukaMulya',
    'alamatKecamatan': 'Padepokan',
    'alamatKabupaten': 'Bogor',
    'alamatProvinsi': 'Jawa Barat'
  },
];

const getPemerintahById = (kode) => {
  return (kode === undefined) ? Items[0] : Items.find(x => x.kode === kode);
};

const getPemerintah = (limit) => {
  return (limit) ? Items.slice(0, limit) : Items;
};

export {
  Items,
  getPemerintah,
  getPemerintahById
};